import React from 'react';
import { Play } from 'lucide-react';
import { EVENT_TYPES } from '@/shared/constants/event-types.v4';

interface ComposerFooterProps {
    status: string;
    type: string;
    programDayId: string | null;
    title: string;
    isLoading: boolean;
    isPastDate: boolean;
    onStart: () => void;
    onSave: () => void;
}

/**
 * ComposerFooter: Handles primary tactical actions (Save, Start, Sync).
 * SHADOW VERSION (.tsx)
 */
export const ComposerFooter: React.FC<ComposerFooterProps> = ({
    status,
    type,
    programDayId,
    title,
    isLoading,
    isPastDate,
    onStart,
    onSave
}) => {
    // Validation logic for button enablement
    const isSaveDisabled = isLoading || 
        (type === EVENT_TYPES.PERFORMANCE && !programDayId) || 
        (type === EVENT_TYPES.TASK && !title);

    const buttonStyle: React.CSSProperties = { 
        all: 'unset', 
        flex: 1, 
        height: '54px', 
        borderRadius: '12px', 
        color: '#000', 
        textAlign: 'center', 
        fontSize: '14px', 
        fontWeight: '900', 
        textTransform: 'uppercase', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        gap: '10px',
        cursor: 'pointer'
    };

    return (
        <footer style={{ 
            padding: '15px', 
            borderTop: '1px solid #222', 
            display: 'flex', 
            gap: '15px', 
            backgroundColor: '#050505', 
            paddingBottom: '30px', 
            flexShrink: 0 
        }}>
            {status === 'PLANNED' && type === EVENT_TYPES.PERFORMANCE && programDayId ? (
                <button 
                    onClick={onStart} 
                    style={{ ...buttonStyle, backgroundColor: isPastDate ? '#f29b11' : '#2ecc71' }}
                    aria-label="Start Session"
                >
                    <Play size={18} fill="#000" /> {isPastDate ? 'LOG' : 'START SESSION'}
                </button>
            ) : (
                <button 
                    onClick={onSave} 
                    disabled={isSaveDisabled} 
                    style={{ 
                        ...buttonStyle, 
                        backgroundColor: '#f29b11', 
                        opacity: isSaveDisabled ? 0.5 : 1,
                        cursor: isSaveDisabled ? 'default' : 'pointer'
                    }}
                    aria-label="Sync Event"
                >
                    {isLoading ? 'SYNCING...' : 'SYNC'}
                </button>
            )}
        </footer>
    );
};
